// extracted by css-extract-rspack-plugin
export default {"definitionBox":"xOGSahubpEiDqGQX","definitionContent":"Rrx3DOfnWuEgOi9b","definitionDivider":"rnA1CatI0uRGa5B4","aggLabel":"J3Gcqx1Dv8bTzqwA","termRow":"HBqnZROvF02114CV"};